var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrusfinanceLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.847,
    height: 48.847,
    viewBox: "0 0 48.847 48.847",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7881",
    "data-name": "Group 7881",
    transform: "translate(-771.173 -625.649)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6510",
    "data-name": "Rectangle 6510",
    width: 7.206,
    height: 12.518,
    transform: "translate(796.408 655.981) rotate(-45)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9143",
    "data-name": "Path 9143",
    d: "M74.972,46.229l-5.1-5.1L45.453,65.557l5.1,5.1,9.663-9.663,3.758,3.757,5.1-5.1-3.757-3.758Z",
    transform: "translate(725.72 584.516)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9144",
    "data-name": "Path 9144",
    d: "M108.807,80.065,99.144,70.4l-4.027-4.027L94.048,65.3,69.624,89.728l5.1,5.1L94.048,75.5l9.664,9.664Z",
    transform: "translate(711.213 570.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6511",
    "data-name": "Rectangle 6511",
    width: 4.81,
    height: 4.81,
    transform: "translate(792.195 671.095) rotate(-45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrusfinanceLogoDark);
export default __webpack_public_path__ + "static/media/trusfinance-logo-dark.194abf05a55f60ff6c018ed95acf8cfe.svg";
export { ForwardRef as ReactComponent };